import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../api.service';
import { CommonService } from '../../../shared/common.service';
import { HostListener } from '@angular/core';
@Component({
  selector: 'app-vital-signs',
  templateUrl: './vital-signs.component.html',
  styleUrl: './vital-signs.component.scss'
})
export class VitalSignsComponent implements OnInit {
  formName: string = 'vital-signs';
  queryParams: any = {};
  

  studyId: string | null = null;
  subjectId: string | null = null;
  studyCode: any;
  studyName: any;
  siteLocation: any;
  subjectName: string | null;
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: any;
  folderName: any;
  formData: any = {
    vitalsignsLogs: []
  };
  vitalParameters: string[] = [
    "1. Temperature (Oral) (Normal Range: 36.1 - 37.5 °C)",
    "2. Pulse Rate (Normal Range: 60-100 beats/min)",
    "3. Respiratory Rate (Normal Range: 12-20 breaths/min)",
    "4. Systolic Blood Pressure (Normal Range: 90-120 mmHg)",
    "5. Diastolic Blood Pressure (Normal Range: 60-80 mmHg)"
  ];
  
  vitalSignsData = this.vitalParameters.map(() => ({
    parameter: '', // Add the 'parameter' field
    value: '',
    result: '',
    abnormal: ''
  }));
  sectionNames = ['Screening', 'Baseline', 'Follow-up'];

vitalSignsBySection: {
  [section: string]: {
    data: any[],
    isDisabled: boolean,
    editReason: string,
    reviewOptions: { dataMonitor: boolean; monitor: boolean; pi: boolean }
  }
} = {};
  //query code
   tabs = [
  { title: 'Query', type: 'query' },
  { title: 'Field History', type: 'fieldHistory' }
];
 //review code
isReviewCheckboxDisabled: boolean = true;
userDesignation: string = '';

  fieldHistoryData: any[] = [];
  selectedTab = 0;
  isOptionsModalOpen = false;
  isModalOpen = false;
  queryText = '';
  // closeQuery = false;
  auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
  queries: {
    selectedField: any; threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] 
}[] = [
  { selectedField: null, threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
];
  selectedOption = 'query'; // Default to Query section
 showReviewModal = false;
  query: { auditTrail: any; };
  fieldLabel: string | null = null; // Add this at the top
  // query code end
  isVitalSignsLogDisabled = false;          // *** NEW
  isReasonModalOpen       = false;          // *** NEW
  editReason              = '';             // *** NEW
  activeSection: string | null = null;
  auditTrailData: any;
  hasDeviationData: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}
  ngOnInit(): void {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;
      const userData = this.commonService.getUserData();
  console.log('User Data from Cookie:', userData);

  this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
  
  const isLoggedIn = this.commonService.isLoggedIn();
  console.log('Is Logged In:', isLoggedIn);

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'vital-signs';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.subjectId = queryParams['subjectId'];
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }
            this.mapStudyDetails(response.studyDetails);
             // Dynamically update informedConsentDate from the response
             if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;  // Set min date
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }
            // Store the gender from the response
          this.gender = response.gender;
          console.log("gender:",this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    } else {
      console.error('Missing required parameters: studyId, subjectId, folderName, or formName.');
    }
     this.sectionNames.forEach(section => {
    this.vitalSignsBySection[section] = {
      data: this.vitalParameters.map(p => ({
        parameter: p, value: '', result: '', abnormal: ''
      })),
      isDisabled: false,
      editReason: '',
      reviewOptions: { dataMonitor: false, monitor: false, pi: false }
    };
  });
  }
//


  addTab(label: string = 'Date of Study Completion') {
  const fieldName = label.trim(); // You can enhance this mapping if needed

  this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
    .subscribe({
      next: (response) => {
        console.log('Fetched Field History for', fieldName, response);
        this.fieldHistoryData = response.data || [];
        
        // Add tab only after fetching data
        this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
        this.selectedTab = this.tabs.length - 1;
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
}


generateThreadId(): string {
  return 'thread-' + Math.random().toString(36).substr(2, 9);
}







  selectTab(index: number) {
    this.selectedTab = index;
    const selected = this.tabs[index];
    const section = this.activeSection || 'Unknown';
  if (selected.type === 'query') {
    // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
    const fieldName = this.fieldLabel || `${section} - Vital Sign`|| 'Unknown Field';
    console.log('Fetching Query History for Field:', fieldName); // <-- Add this
    this.apiService.getQueryHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Query History Data:', response);
        // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
        // Example: populate audit trails per query
         if (response.data && Array.isArray(response.data)) {
          const auditTrail = response.data.map((item: any) => {
            const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
            return {
              user: item.updated_by || 'Unknown',
              
              timestamp: subData.timestamp || item.updated_at,
              message: item.value || ''
            };
          });
         this.auditTrailData = auditTrail;
        }else {
          console.warn('No query data found or data is not an array');
        }
      },
      error: (error) => {
        console.error('Error fetching query history data:', error);
      }
    });
  }
  if (selected.type === 'fieldHistory') {
    this.fieldHistoryData = [];
      this.vitalSignsData.forEach((_, index) => {
        const fieldName = `${section} - Vital Sign ${index + 1}`; // e.g. VitalSign1, VitalSign2…
        this.apiService.getInsertHistoryData(
          this.studyId, this.subjectId, this.folderName, this.formName, fieldName
        ).subscribe({
          next: r => {
            if (Array.isArray(r.data)) this.fieldHistoryData.push(...r.data);
          },
          error: e => console.error(`Error fetching history for ${fieldName}`, e)
        });
      });

    const fieldName = this.fieldLabel || 'Unknown Field';
    console.log('Fetching Field History for:', fieldName);
    this.apiService.getInsertHistoryData(
      this.studyId,
      this.subjectId,
      this.folderName,
      this.formName,
      fieldName
    ).subscribe({
      next: (response) => {
        console.log('Fetched Field History Data:', response);
        this.fieldHistoryData = response.data || [];
      },
      error: (error) => {
        console.error('Error fetching field history data:', error);
      }
    });
  }

}
  
  closeTab(index: number, event: MouseEvent) {
    event.stopPropagation();
    this.tabs.splice(index, 1);
    if (this.selectedTab >= this.tabs.length) {
      this.selectedTab = this.tabs.length - 1;
    }
  }
openReviewModal() {
  this.showReviewModal = true;
}

closeReviewModal() {
  this.showReviewModal = false;
}
openOptionsModal(event: MouseEvent, target: EventTarget | null, section: string) {
  event.stopPropagation();
  this.isOptionsModalOpen = true;
  this.activeSection = section; // Set section context

  const icon = target as HTMLElement;
  const fieldGroup = icon.closest('.form-group');

  if (fieldGroup) {
    this.fieldLabel = fieldGroup.getAttribute('data-label');
    console.log('Captured Label:', this.fieldLabel);
  }
}




openModal() {
  if (!this.activeSection) {
    alert("No section selected");
    return;
  }
  this.isModalOpen = true;
  this.selectedTab = 0; // Default to 'Query'
  const section = this.activeSection;
  // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
  const fieldName = this.fieldLabel ||  `${section} - Vital Sign`||'Unknown Field';
 console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

  this.apiService.getQueryHistoryData(
    this.studyId,
    this.subjectId,
    this.folderName,
    this.formName,
    fieldName
  ).subscribe({
    next: (response) => {
      console.log('Fetched Query History Data:', response);

      if (response.success && Array.isArray(response.data)) {
        this.queries = response.data.map((entry: any) => {
          const auditTrail = entry.auditTrail?.map((a: any) => ({
            user: a.user,
            timestamp: a.timestamp,
            message: typeof a.message === 'string' ? a.message : String(a.message)
          })) || [];

          const isClosed = auditTrail.some(item => 
  typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
);

const query = {
  selectedField: entry.auditTrail?.[0]?.selectedField || '',
  threadId: entry.threadId || 'no-thread',
  text: this.getInitialQueryText(auditTrail) || '',
  isClosed: isClosed,
  auditTrail: auditTrail
};

         

          return query;
        });
      } else {
        // Fallback for empty or invalid data
        this.queries = Array(3).fill(null).map(() => ({
           selectedField: null,
          threadId: this.generateThreadId(),
          text: '',
          isClosed: false,
          auditTrail: []
        }));
      }
    },
    error: (error) => {
      console.error('Error fetching query history:', error);
      this.queries = [{
         selectedField: null,
        threadId: this.generateThreadId(),
        text: '',
        isClosed: false,
        auditTrail: []
      }];
    }
  });
/* -------------------------------------------------------------
   * 2. FIELD‑HISTORY FETCH (NEW – mirrors IDRS)
   * ------------------------------------------------------------- */
  if (this.formName === 'vital-signs' && Array.isArray(this.vitalSignsData)) {
    this.fieldHistoryData = [];
    this.vitalSignsData.forEach((_, index) => {
      const historyFieldName = `${section} - Vital Sign ${index + 1}`;   // <-- must match backend
      this.apiService.getInsertHistoryData(
        this.studyId,
        this.subjectId,
        this.folderName,
        this.formName,
        historyFieldName
      ).subscribe({
        next: (resp) => {
          console.log(`History for ${historyFieldName}:`, resp);
          if (Array.isArray(resp.data)) {
            this.fieldHistoryData.push(...resp.data);
          }
        },
        error: (err) => {
          console.error(`Error fetching history for ${historyFieldName}:`, err);
        }
      });
    });
  }
}


editStudy() {                       // *** NEW
    this.isReasonModalOpen = true;    // *** NEW
  }                                   // *** NEW

  confirmEditReason() {   
    if (!this.activeSection) return;            // *** NEW
    if (!this.editReason.trim()) {    // *** NEW
      alert('Please enter a reason'); // *** NEW
      return;                         // *** NEW
    }                                 // *** NEW
    const section = this.activeSection;
  this.vitalSignsBySection[section].isDisabled = false;
  this.vitalSignsBySection[section].editReason = this.editReason.trim();
  this.isReasonModalOpen = false;
  }                                   // *** NEW

  cancelEditReason() {                // *** NEW
    this.isReasonModalOpen = false;   // *** NEW
    this.editReason        = '';      // *** NEW
  }                                   // *** NEW


getInitialQueryText(auditTrail: any[]): string {
  if (!Array.isArray(auditTrail)) return '';

  // Look for latest message or first valid message in each query's auditTrail
  const validEntry = auditTrail
    .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
    .pop(); // or use [0] for first message

  return validEntry ? validEntry.message : '';
}

closeModal() {
  this.isModalOpen = false;
  document.body.classList.remove('modal-open');
}


addQuery(index: number) {
  this.queries.splice(index + 1, 0, {
     selectedField: null,
    threadId: this.generateThreadId(),
    text: '',
    isClosed: false,
    auditTrail: []
  });
}
submitQuery(index: number) {
  const userData = this.commonService.getUserData(); // Extract from cookies
  console.log('userData:', userData); // Check the structure
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A'; // Fallback if not available

  const timestamp = new Date().toISOString(); // ISO format for backend

  const query = this.queries[index];
  const section = this.activeSection || 'Unknown';
  if (!query.text || !query.text.trim()) {
    console.warn('No text entered for this query. Ignoring submit.');
    return;
  }

  // Ensure threadId
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }
  
  if (!query.selectedField) {
  console.warn('No field selected for the query.');
  alert('Please select a field from the dropdown before submitting.');
  return;
}

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName :this.fieldLabel || `${section} - Vital Sign`|| 'Unknown Field',
    threadId: query.threadId,
    queryText: query.text.trim(),
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    selectedField: query.selectedField || '' // <-- ADD THIS LINE
  };
   console.log('Submitting Query Payload:', payloadItem); // <-- Important log

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query submitted:', response);

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: new Date().toLocaleString(),
        message: payloadItem.queryText
      });
 query.text = ''; // Clear only this one
    },
    error: (error) => {
      console.error('Error submitting query:', error);
    }

     
    });
  }

reviewOptions = {
  dataMonitor: false,
  monitor: false,
  pi: false
};
 
confirmCloseQuery(index: number): void {
  const confirmed = window.confirm('Are you sure you want to close this query?');
  if (confirmed) {
    this.closeQuery(index);
  }
}
closeQuery(index: number): void {
  const userData = this.commonService.getUserData();
  const fullName = `${userData.first_name} ${userData.last_name}`;
  const designation = userData.designation || 'N/A';
  const timestamp = new Date().toISOString(); // For backend
  const localTime = new Date().toLocaleString(); // For UI
  const section = this.activeSection || 'Unknown';
  const query = this.queries[index];
  if (!query.threadId) {
    query.threadId = this.generateThreadId();
  }

  const closeMessage = 'Query closed';

  const payloadItem = {
    studyId: this.studyId,
    subjectId: this.subjectId,
    folderName: this.folderName,
    formName: this.formName,
    // fieldName: '2. Date of Study Completion:',
    fieldName : this.fieldLabel || `${section} - Vital Sign`||'Unknown Field',
    threadId: query.threadId,
    queryText: closeMessage,
    user: fullName,
    designation: designation,
    timestamp: timestamp,
    isClosed: true  // Optional, in case your backend expects a flag
  };

  this.apiService.submitQueryData([payloadItem]).subscribe({
    next: (response) => {
      console.log('Query closed:', response);
      

      query.auditTrail = query.auditTrail || [];
      query.auditTrail.push({
        user: fullName,
        role: designation,
        timestamp: localTime,
        message: closeMessage
      });
      query.isClosed = true;
      alert('Query closed successfully');
    },
    error: (error) => {
      console.error('Error closing query:', error);
    }
  });
}
confirmSubmitQuery(index: number): void {
  const confirmSubmit = confirm('Are you sure you want to submit the data?');
  if (confirmSubmit) {
    this.submitQuery(index);
    alert('Data submitted successfully');
  }
}

//
  // Function to map study details
  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code ?? 'N/A';
      this.studyName = studyDetails.study_name ?? 'Unknown Study';
      this.siteLocation = studyDetails.site_location ?? 'Unknown Location';
      this.subjectName = this.subjectId;

      console.log("Mapped Study Details:", {
        studyCode: this.studyCode,
        studyName: this.studyName,
        siteLocation: this.siteLocation,
        subjectName: this.subjectName,
      });
    } else {
      console.warn('Study details are missing or undefined.');
    }
  }

hasStudyCompleteData = false;

mapFormData(rows: any[]): void {
  this.hasStudyCompleteData = false;


  // Initialize section-wise data structure if not already done
  console.log("Mapping section-wise Vital Signs data...");

  let hasData = false;

  // Initialize section-wise structure
  this.sectionNames.forEach(section => {
    

    
    if (!this.vitalSignsBySection[section]) {
      this.vitalSignsBySection[section] = {
        data: this.vitalParameters.map(p => ({
          parameter: p, value: '', result: '', abnormal: ''
        })),
        isDisabled: false,
        editReason: '',
        reviewOptions: { dataMonitor: false, monitor: false, pi: false }
      };
    }
  });

  rows.forEach(r => {
    const sectionMatch = r.field_name?.match(/^(Screening|Baseline|Follow-up)/i);
    if (!sectionMatch) return;

    const section = sectionMatch[1];
    const sectionData = this.vitalSignsBySection[section];
    if (!sectionData) return;

    const fieldName = r.field_name?.trim().toLowerCase();

    // ✅ Apply review_status from backend
    if (r.review_status) {
      try {
        const parsedStatus = typeof r.review_status === 'string'
          ? JSON.parse(r.review_status)
          : r.review_status;

        sectionData.reviewOptions.dataMonitor ||= parsedStatus.dataMonitor || false;
        sectionData.reviewOptions.monitor ||= parsedStatus.monitor || false;
        sectionData.reviewOptions.pi ||= parsedStatus.pi || false;
      } catch (e) {
        console.warn("Invalid review_status JSON:", r.review_status);
      }
    }

    // ✅ Handle legacy review checkbox names in field_name (optional fallback)
    if (fieldName.includes('reviewedbydatamonitor')) {
      sectionData.reviewOptions.dataMonitor = r.value === 'true';
    } else if (fieldName.includes('reviewedbymonitor')) {
      sectionData.reviewOptions.monitor = r.value === 'true';
    } else if (fieldName.includes('reviewedbypi')) {
      sectionData.reviewOptions.pi = r.value === 'true';
    }

    // ✅ Handle sub_data mapping
    if (r.sub_data) {
      let sub: any = {};
      try {
        sub = typeof r.sub_data === 'string' ? JSON.parse(r.sub_data) : r.sub_data;
      } catch {
        console.warn('Invalid JSON in sub_data → skipped:', r.sub_data);
        return;
      }

      const entryIndex = sectionData.data.findIndex(p => p.parameter === sub.parameter);
      if (entryIndex !== -1) {
        sectionData.data[entryIndex] = {
          parameter: sub.parameter ?? this.vitalParameters[entryIndex],
          value: sub.value ?? '',
          result: sub.result ?? '',
          abnormal: sub.abnormal ?? ''
        };

        if (sub.value || sub.result || sub.abnormal) {
          hasData = true;
        }
      }
    }
  });

  // ✅ Disable section if it has any data
  this.sectionNames.forEach(section => {
    const sectionData = this.vitalSignsBySection[section];
    sectionData.isDisabled = sectionData.data.some(
      row => row.value || row.result || row.abnormal
    );
  });

  this.hasDeviationData = hasData;

  console.log('✅ Mapped Section-wise Vital Signs with Review:', this.vitalSignsBySection);
}


  validateVitalSigns(section: string) {
    const temperaturePattern = /^\d{2,3}\.\d$/; // 2 or 3 digits followed by . and 1 decimal place
    const twoOrThreeDigitPattern = /^\d{2,3}$/; // 2 or 3 digits
    const oneOrTwoDigitPattern = /^\d{1,2}$/; // 1 or 2 digits
  
    for (let i = 0; i < this.vitalSignsData.length; i++) {
      const value = this.vitalSignsData[i].value;
      const parameter = this.vitalParameters[i];
  
      if (parameter.includes("Temperature") && value && !temperaturePattern.test(value)) {
        alert(`Invalid Temperature format. Please enter in 99.0 or 100.5 format.`);
        return;
      }
  
      if (parameter.includes("Pulse Rate") && value && !twoOrThreeDigitPattern.test(value)) {
        alert(`Invalid Pulse Rate. Please enter a 2 or 3-digit value.`);
        return;
      }
  
      if (parameter.includes("Respiratory Rate") && value && !oneOrTwoDigitPattern.test(value)) {
        alert(`Invalid Respiratory Rate. Please enter a 1 or 2-digit value.`);
        return;
      }
  
      if (parameter.includes("Systolic Blood Pressure") && value && !twoOrThreeDigitPattern.test(value)) {
        alert(`Invalid Systolic Blood Pressure. Please enter a 2 or 3-digit value.`);
        return;
      }
  
      if (parameter.includes("Diastolic Blood Pressure") && value && !twoOrThreeDigitPattern.test(value)) {
        alert(`Invalid Diastolic Blood Pressure. Please enter a 2 or 3-digit value.`);
        return;
      }
    }
  
     // ✅ Pass section here
  this.submitVitalSigns(section);
  }
  

  submitVitalSigns(section: string) {
    const sectionData = this.vitalSignsBySection[section];
    console.log("Before Extracting Vital Signs Data:", this.vitalSignsData);
    const userData  = this.commonService.getUserData();
    const fullName  = `${userData.first_name} ${userData.last_name}`;

    let questionAnswers: { [key: string]: any } = {};

    if (this.formName === 'vital-signs' && Array.isArray(this.vitalSignsData)) {
         sectionData.data.forEach((vital, index) => {
    const key = `${section} - Vital Sign ${index + 1}`;
    questionAnswers[key] = {
      answer: 'Yes',
      value: {
        parameter: vital.parameter,
        value: vital.value,
        result: vital.result,
        abnormal: vital.abnormal
      },
      editReason: sectionData.editReason,
      reviewStatus: { ...sectionData.reviewOptions }
    };
  });
    }

    console.log("Submitted Data:", questionAnswers);

    const submittedData = {
        folderName: this.folderName,
        formName: this.formName,
        studyId: this.studyId,
        subjectId: this.subjectId,
         user:       fullName, 
         section: section,
        //sub_data: JSON.stringify(questionAnswers) // Sending only row data in sub_data
        ...questionAnswers
    };

    console.log("Form Submitted: ${section}", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
        next: (response) => {
            console.log("Response from API:", response);
            alert("Vital Signs Form Submitted Successfully!");
            this.editReason              = '';       // reset
        this.isVitalSignsLogDisabled = true; 
        sectionData.isDisabled = true; 
        },
        error: (error) => {
            console.error("Error submitting vital signs form:", error);
            alert("Error submitting form. Please try again.");
        }
    });
}

goBack() {
  this.router.navigate(['/study-details', this.studyId]);
}
//new + import line to allow. closing of panel
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = (event.target as HTMLElement)?.closest('.options-modal');
    if (!clickedInside) {
      this.isOptionsModalOpen = false;
    }
  }
}